import React, { useEffect, useMemo } from 'react';

import { useToast } from './ToastProvider';

import * as Styles from './ToastStyles';

import { ReactComponent as Alert } from '../../../assets/icons/icon_alert.svg';
import { ReactComponent as Close } from '../../../assets/icons/icon_close.svg';

import { ToastProps } from './interfaces';

const Toast: React.FC<ToastProps> = ({ id = 0, title, description }) => {
  /*
   * Hooks
   */
  const { removeToast } = useToast();

  const toastVariants = useMemo(() => ({
    hidden: { x: '-100%', opacity: 0 },
    visible: { x: 0, opacity: 1 },
  }), []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      removeToast(id);
    }, 4000);

    return () => {
      clearTimeout(timeout);
    };
  }, [id, removeToast]);

  return (
    <Styles.Container role="alert" variants={toastVariants} initial="hidden" animate="visible" exit="hidden">
      <Alert />

      <Styles.Content>
        <Styles.Title>{title}</Styles.Title>

        <Styles.Description>{description}</Styles.Description>
      </Styles.Content>

      <Styles.Button type="button" onClick={() => removeToast(id)}>
        <Close />
      </Styles.Button>
    </Styles.Container>
  );
};

export default Toast;
